import { render, staticRenderFns } from "./shelf_channel_dialog.vue?vue&type=template&id=2d39cc3e&scoped=true"
import script from "./shelf_channel_dialog.vue?vue&type=script&lang=js"
export * from "./shelf_channel_dialog.vue?vue&type=script&lang=js"
import style0 from "./shelf_channel_dialog.vue?vue&type=style&index=0&id=2d39cc3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d39cc3e",
  null
  
)

export default component.exports